import { Icon } from "../design-system/Icon";
import { useAppStore } from "../state/app-store";
import { strings } from "../i18n/es-CL";
import { NotificationsCenter } from "../features/notifications/NotificationsCenter";
import { AccountSwitcher } from "./AccountSwitcher";
import { DateRangeFilter } from "../components/DateRangeFilter";

export function Topbar(): JSX.Element {
  const theme = useAppStore((s) => s.theme);
  const toggleTheme = useAppStore((s) => s.toggleTheme);
  const toggleSidebar = useAppStore((s) => s.toggleSidebar);
  const isDark = theme === "dark";

  return (
    <header className="topbar">
      <button
        type="button"
        className="iconbtn"
        onClick={toggleSidebar}
        aria-label="Alternar menú lateral"
      >
        <Icon name="analytics" size={18} />
      </button>

      <label className="search">
        <Icon name="search" size={17} />
        <input id="global-search" type="search" placeholder={strings.search} aria-label={`${strings.search} (Ctrl+K)`} />
      </label>

      <div className="spacer" />

      <DateRangeFilter />

      <AccountSwitcher />

      <button
        type="button"
        className="iconbtn"
        onClick={toggleTheme}
        aria-label={isDark ? strings.themeLight : strings.themeDark}
        title={isDark ? strings.themeLight : strings.themeDark}
      >
        <Icon name={isDark ? "sun" : "moon"} size={18} />
      </button>

      <NotificationsCenter />
    </header>
  );
}
